/**
 * Tilauslistanäkymän otsikko ja napit
 */

import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MapPin, Plus } from "lucide-react";

interface OrdersHeaderProps {
  onCreateOrder: () => void;
}

export function OrdersHeader({ onCreateOrder }: OrdersHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between">
      <h1 className="text-3xl font-bold">Tilaukset</h1>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => navigate("/orders/map")}>
          <MapPin className="h-4 w-4 mr-2" />
          Karttanäkymä
        </Button>
        <Button onClick={onCreateOrder}>
          <Plus className="h-4 w-4 mr-2" />
          Luo uusi tilaus
        </Button>
      </div>
    </div>
  );
}
